<script setup>
// §8.2 Card — surface + 1px line. NO shadow (§4). Shadow is reserved for things
// that genuinely float; a page of shadowed cards reads as a template.
// Slots: header / default (body) / footer.
</script>

<template>
  <section class="l-card">
    <div v-if="$slots.header" class="hd"><slot name="header" /></div>
    <div class="bd"><slot /></div>
    <div v-if="$slots.footer" class="ft"><slot name="footer" /></div>
  </section>
</template>

<style scoped>
.l-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  padding: var(--sp-5) var(--sp-6);
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}
.hd,
.bd,
.ft {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.ft {
  flex-direction: row;
  align-items: center;
  gap: var(--sp-2);
}
</style>
